/**
 *
 * Asynchronously loads the component for GroupManagement
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GroupManagement = lazyLoad(
  () => import('./index'),
  module => module.GroupManagement
);
